import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { RedirectingBackToScreen } from './molecules/RedirectingBackToScreen';

export const sanitizeUrl = (url: string): string => {
  // https://github.com/facebook/react/blob/main/packages/react-dom/src/shared/sanitizeURL.js
  const isJavaScriptProtocol =
    // eslint-disable-next-line no-control-regex
    /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;

  if (isJavaScriptProtocol.test(url)) {
    // Redirect to the safe url to trigger an Application Error
    return '/result/redirect';
  }

  return url;
};

type PrettyRedirectProps = RouteComponentProps<{
  clientAppDeeplink: string;
  clientName: string;
}> & {
  windowLocal?: typeof window;
};

export const RedirectBackToClient: React.FC<PrettyRedirectProps> = ({
  match,
  windowLocal = window,
}) => {
  const clientName = window.decodeURIComponent(match.params.clientName);
  const appDeeplink = sanitizeUrl(window.decodeURIComponent(match.params.clientAppDeeplink));

  useEffect(() => {
    setTimeout(() => {
      windowLocal.location.href = appDeeplink;
    }, 1400);
  }, [windowLocal, appDeeplink]);

  useEffect(() => {
    windowLocal.onblur = () => {
      windowLocal.close();
    };
  }, [windowLocal]);

  return <RedirectingBackToScreen clientName={clientName} />;
};
